export class GenericDocumentCloneDTO {
  sourceGenericDocHdrGuid: string;
  /** This field is populated in the server's response */
  cloneGenericDocHdrGuid: string;
  /** Should be false by default */
  includeAttachments: boolean;
}